export * from './src/service-fees-v1-rule-service-fees.universal.js';
